import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const RedirectHandler: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const path = location.pathname;
    console.log("RedirectHandler activated with path:", path);

    if (path.endsWith('/success')) {
      // Handle successful payment
      console.log("Setting subscription status to true");
      localStorage.setItem('status','true');
      localStorage.setItem('status2','true');
      
      // Redirect to the new success page
      navigate('/dashboard/subscription-success', { replace: true });
    } else if (path.endsWith('/cancel')) {
      // Handle canceled payment
      // alert('Payment canceled!');
      navigate('/dashboard/subscriptions');
    }
  }, [location.pathname, navigate]);

  // Show a loading indicator while redirecting
  return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <p>Processing your payment information...</p>
  </div>;
};

export default RedirectHandler;
